export default __webpack_public_path__ + "static/media/Samoore's Staff of Divinity.eabde564.jpg";